export const TOUR_DISCOUNT_CAMPAIGNS_CREATE_START = "TOUR_DISCOUNT_CAMPAIGNS_CREATE_START";
export const TOUR_DISCOUNT_CAMPAIGNS_CREATE_SUCCESS = "TOUR_DISCOUNT_CAMPAIGNS_CREATE_SUCCESS";
export const TOUR_DISCOUNT_CAMPAIGNS_CREATE_ERROR = "TOUR_DISCOUNT_CAMPAIGNS_CREATE_ERROR";

export const TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_START = "TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_START";
export const TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_SUCCESS = "TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_SUCCESS";
export const TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_ERROR = "TOUR_DISCOUNT_ALL_CAMPAIGNS_DETAILS_ERROR";

export const TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_START = "TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_START";
export const TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_SUCCESS = "TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_SUCCESS";
export const TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_ERROR = "TOUR_DISCOUNT_LIVE_CAMPAIGNS_DETAILS_ERROR";

export const TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_START = "TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_START";
export const TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_SUCCESS = "TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_SUCCESS";
export const TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_ERROR = "TOUR_DISCOUNT_SCHEDULED_CAMPAIGNS_DETAILS_ERROR";

export const DISCOUNT_SCHEDULE_CAMPAIGNS_LIVE_FILTER_SUCCESS = "DISCOUNT_SCHEDULE_CAMPAIGNS_LIVE_FILTER_SUCCESS";
export const DISCOUNT_SCHEDULE_CAMPAIGNS_SCHEDULE_FILTER_SUCCESS = "DISCOUNT_SCHEDULE_CAMPAIGNS_SCHEDULE_FILTER_SUCCESS";